<div class="cm-menu-container">
    <ng-content></ng-content>
</div>
